var module = angular.module('octopusApp.certificates');

module.controller('CertificateDownloadDialogController', function ($scope, certificate, $uibModalInstance, octopusRepository) {

    $scope.certificate = certificate;

    $scope.exportOptions = {
        format: null,
        password: {}
    };

    $scope.downloadUrl = function() {
       var args = {
           format: $scope.exportOptions.format
       };

       if ($scope.exportOptions.password.NewValue) {
           args.password = $scope.exportOptions.password.NewValue;
       }

       if ($scope.exportOptions.format === "PEM") {
           args.includePrivateKey = $scope.exportOptions.includePrivateKey;
       }

       return octopusRepository.resolve($scope.certificate.Links["Export"], args);
    };

    $scope.close = function () {
        $uibModalInstance.close();
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/details/certificate_download_dialog_controller.js
// module id = 4443001230705981
// module chunks = 1